import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Links, Meta } from '../../../../../src/app/core/models/generic-models';
import * as fromPaymentsAndStatementsActions from '../actions';
import { PaymentRun } from '../dto/pyament-run.dto';

export const paymentRunFeatureKey = 'paymentRun';

export interface State extends EntityState<PaymentRun> {
  loaded: boolean;
  links: Links;
  meta: Meta;
  error?: Error | any;
}

export const adapter: EntityAdapter<PaymentRun> = createEntityAdapter<PaymentRun>({
  selectId: item => item.userTransactionId
});

export const initialState: State = adapter.getInitialState({
  loaded: false,
  links: undefined,
  meta: undefined
});

export const reducer = createReducer(
  initialState,
  on(fromPaymentsAndStatementsActions.loadPaymentRuns, state => state),
  on(fromPaymentsAndStatementsActions.loadPaymentRunsSuccess, (state, { data }) =>
    adapter.setAll(data.items, {
      ...state,
      meta: data.meta,
      links: data.links,
      loaded: true
    })
  ),
  on(fromPaymentsAndStatementsActions.loadPaymentRunsFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: false
  }))
);

// get the selectors from built in adapter
export const { selectIds, selectEntities, selectAll } = adapter.getSelectors();
